export default "__VITE_ASSET__$mx8P04v__"